import React, { useState } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import CustomButton from 'Components/CustomButton/CustomButton'

import { useForm } from 'react-hook-form'
import { makePostRequest } from 'utils/api'

import { Box, useMediaQuery, useTheme } from '@mui/material'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import TextField from '@mui/material/TextField'

export default function ExportData() {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [open, setOpen] = useState(false)
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [startError, setStartError] = useState(false)
  const [endError, setEndError] = useState(false)
  const {
    handleSubmit,

    reset,

    formState: { errors },
  } = useForm({
    defaultValues: {},
  })

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    reset()
    setOpen(false)
    setEndDate(null)
    setStartDate(null)
  }

  const onSubmit = async (data) => {
    if (startDate && endDate) {
    } else {
      setStartError(true)
      setEndError(true)
      return
    }
    let payload = {
      start_date: startDate.format('YYYY-MM-DD'),
      end_date: endDate.format('YYYY-MM-DD'),
    }

    const response = await makePostRequest(
      '/api/Professional/workentrie-export/',

      payload,
      { custom: { responseType: 'blob' } },
      true,
    )
    if (response.status === 200) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'workentrie_export.xlsx')
      document.body.appendChild(link)
      link.click()
      link.remove()
      handleClose()
    }
  }

  return (
    <>
      <CustomButton onClick={handleClickOpen}>Export</CustomButton>

      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle sx={{ color: 'Black !important' }}>Export</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
          <DialogContent>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, maxWidth: 300 }}>
                <DatePicker
                  label="Start Date"
                  value={startDate}
                  onChange={(newValue) => {
                    setStartDate(newValue)
                    if (newValue) setStartError(false)
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      required
                      error={startError}
                      helperText={startError ? 'Start date is required' : ''}
                    />
                  )}
                />
                <DatePicker
                  label="End Date"
                  value={endDate}
                  onChange={(newValue) => {
                    setEndDate(newValue)
                    if (newValue) setEndError(false)
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      required
                      error={endError}
                      helperText={endError ? 'End date is required' : ''}
                    />
                  )}
                />
              </Box>
            </LocalizationProvider>
          </DialogContent>
          <DialogActions>
            <Button type="submit">Valider</Button>
            <Button onClick={handleClose}>Annuler</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
